// Module
var code = `<div class="rb-dialog rb-notification working"> <div class="header"> <div class="icon"> <rb-loading class="big-white"></rb-loading> </div> <div class="text"> <h3 ng-bind="VM.title"></h3> <h1 ng-bind="VM.subtitle">Loading...</h1> </div> </div> </div> `;
// Exports
export default code;